import React from 'react'
import { makeStyles } from '@material-ui/core'
import { theme } from '../../../../../../../../../Assets/Styles/theme'

const useStyles = makeStyles(() => {
  return {
    sectionWrapper: {
      display: 'flex',
    },
    baseItem: {
      borderBottom: '1px solid black',
      paddingBottom: 10,
    },
    buttonItem: {
      cursor: 'pointer',
      fontSize: '16px',
      fontWeight: 'bold',
    },
    separatorItem: { width: 20 },
    emptyItem: {
      flexGrow: 1,
    },
    selectedItem: {
      borderBottom: `3px solid ${theme.colors.primary}`,
    },
  }
})

export const SequenceStatusToggle = ({
  seqStatus,
  setSeqStatus,
  totalActive,
  totalArchived,
}) => {
  const {
    sectionWrapper,
    baseItem,
    emptyItem,
    selectedItem,
    separatorItem,
    buttonItem,
  } = useStyles()

  return (
    <div className={sectionWrapper}>
      <div
        className={`${baseItem} ${buttonItem} ${
          seqStatus === 'ACTIVE' ? selectedItem : ''
        }`}
        onClick={() => setSeqStatus('ACTIVE')}
      >
        {`Sequences ${totalActive !== undefined ? `(${totalActive})` : ''}`}
      </div>
      <div className={`${baseItem} ${separatorItem}`} />
      <div
        className={`${baseItem} ${buttonItem} ${
          seqStatus === 'ARCHIVED' ? selectedItem : ''
        }`}
        onClick={() => setSeqStatus('ARCHIVED')}
      >
        {`Archived Sequences ${
          totalArchived !== undefined ? `(${totalArchived})` : ''
        }`}
      </div>
      <div className={`${baseItem} ${emptyItem}`} />
    </div>
  )
}
